import { useQuery } from '@tanstack/react-query';

import { Revendedor } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { useShowError } from 'hooks/useShowError';

export function useQueryRevendedor() {
    const requestListagem = useRequestListagem();
    const { filter, autoLoad, page, limit, sort } = useListagemContext();
    const { showError } = useShowError();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/revendedorwrapper',
        nested: true,
        sort: sort?.length ? sort : [{ property: 'idRevendedor', direction: 'DESC' }],
        filter,
        page,
        limit,
    };

    return useQuery<RequestListagem<Revendedor[]>>([requestOptions], () => requestListagem(requestOptions).then((res) => res.data), {
        enabled: autoLoad,
        onError: (res) => showError(res),
    });
}
